import {
  prefetchPartnersProfileGuideRetrieveQuery,
  usePartnersProfileGuideRetrieve,
} from "@boundless/bl-api-client/partners/services"
import { createFileRoute } from "@tanstack/react-router"
import Markdown from "react-markdown"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export const Route = createFileRoute("/_dashboard/partners/guide")({
  component: RouteComponent,
  loader: async ({ context: { queryClient } }) => {
    await prefetchPartnersProfileGuideRetrieveQuery(queryClient)
  },
})

function RouteComponent() {
  const { data: guide, isSuccess } = usePartnersProfileGuideRetrieve({
    query: { throwOnError: true },
  })
  if (!isSuccess) {
    return <div>Loading...</div>
  }
  return (
    <Card>
      <CardHeader>
        <CardTitle>Partner Guide</CardTitle>
        <CardDescription>Last Updated: {guide.date}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="prose w-full max-w-none">
          <Markdown>{guide.copy}</Markdown>
        </div>
      </CardContent>
    </Card>
  )
}
